<template>
  <div class="my-table desktopDotPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('desktopDot.txt1')}}</span>
        <span>{{$t('desktopDot.txt2')}} / {{$t('desktopDot.txt3')}}</span>
      </div>
      <div class="flexEnd">
        <div class="searchBtn" @click="addDesktopDot">{{$t('desktopDot.txt4')}}</div>
      </div>
    </div>
<!--     <div class="searchBox relative">
      <div class="fl">
        <div class="btnC mr2" :class="pageType === 1 ? 'activedBtn' : 'addBtn'" @click="goOnlinePage">
          <img src="@/assets/picture/icon/onlineusers_icon.png" v-if="pageType === 0" width="20"/>
          <img src="@/assets/picture/icon/onlineusers_b_icon.png" v-else width="20"/>
          <span class="btn-txt">在线用户</span>
        </div>
      </div>
    </div> -->
    <!-- 面包屑 -->
    <!-- <el-card class="tableCard" v-if="pageType === 0"> -->
      <el-row :gutter="20" class="cardContent">
        <el-col :span="8" class="cardBox" v-for="(item,index) in dataList" :key="index">
          <el-tooltip placement="right-end" effect="light" popper-class="atooltip" visible-arrow="false">
            <div slot="content" class="modelBox">
              <div class="header">{{item.desktopName?item.desktopName:'--'}}</div>
              <el-form ref="item" label-position="right" :model="item" label-width="80px">
                <el-form-item :label="$t('desktopDot.txt5')">
                  <span>{{item.lanIp?item.lanIp:'--'}}</span>
                </el-form-item>
                <el-form-item :label="$t('desktopDot.txt6')">
                  <span>{{item.wanIp?item.wanIp:'--'}}</span>
                </el-form-item>
                <el-form-item :label="$t('desktopDot.txt7')">
                  <span>{{item.online?$t('desktopDot.txt11'):$t('desktopDot.txt12')}}</span>
                </el-form-item>
                <el-form-item :label="$t('desktopDot.txt8')">
                  <span>{{item.onLineUsers.length}}</span>
                </el-form-item>
                <el-form-item :label="$t('desktopDot.txt9')">
                  <span>{{item.desktopPort}}</span>
                </el-form-item>
                <el-form-item :label="$t('desktopDot.txt10')">
                  <span>{{item.desktopDescribe}}</span>
                </el-form-item>
              </el-form>
            </div>
            <div>
              <div class="header">
                <span>{{item.desktopName?item.desktopName:'--'}}</span>
                <div class="fr">
                  <img @click="handleDistribution(item)" src="@/assets/picture/icon/personnellist_icon.png"/>
                  <img @click="handleEdit(item)" src="@/assets/picture/icon/edit_icon.png"/>
                  <img @click="handleDelete(item)" src="@/assets/picture/icon/delete_S_icon.png"/>
                </div>
              </div>
              <div class="contentBox">
                <div class="flex">
                  <img class="desktopPic" @click="handleEdit(item)" src="@/assets/picture/icon/servicenode_img.png"/>
                  <div>
                    <p>
                      <span class="labelTxt fl">{{$t('desktopDot.txt5')}}</span>
                      <span class="txt fl">{{item.lanIp}}</span>
                    </p>
                    <p >
                      <span class="labelTxt fl">{{$t('calculateDot.txt6')}}</span>
                      <span v-if="item.online" class="txt fl"><span class="dot"></span>{{$t('desktopDot.txt11')}}</span>
                      <span v-else class="txt fl"><span class="dot greenDot"></span>{{$t('desktopDot.txt12')}}</span>
                    </p>
                    <p>
                      <span class="labelTxt fl">{{$t('desktopDot.txt8')}}</span>
                      <span class="txt fl">{{item.onLineUsers.length}}人</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </el-tooltip>
        </el-col>
      </el-row>
  </div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        fromData:{},//分享参数
        //用于获取数据列表
        queryInfo: {
          cmptName:'',
          endCreateTm:'',
          pageNum:0,
          pageSize: 10,
          productTmplCmptId:'',
          projName:'',
          spvTm:'',
          startCreateTm:'',
          submitterName:'',
          witnCde:'',
          witnType:'',
        },
        dataList: [],
        total: 0,
      };
    },
    created() {
      this.loadData();
    },
    methods: {
      // 桌面节点列表
      async loadData() {
        const {data: res} = await this.$http.post("/desktop/list");
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.dataList = res.result;
      },
      // 新建节点
      addDesktopDot(){
        this.$router.push("/editDesktopDot");
      },
      // 用户分配
      handleDistribution(row){
        this.$router.push({path: '/userAssignment', query: {row: encodeURIComponent(JSON.stringify(row))}});
      },
      // 编辑节点
      handleEdit(row){
        this.$router.push({path: '/editDesktopDot', query: {id: row.id}});
      },
      // 删除
      handleDelete(item){
        let id = item.id;
        this.$confirm('<p class="color666 fz14">'+this.$t('desktopDot.txt13')+'</p><p class="color999 fz14">'+this.$t('desktopDot.txt14')+'</p>', this.$t('desktopDot.txt15'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('desktopDot.txt16'),
          cancelButtonText: this.$t('desktopDot.txt17'),
          type: 'warning',
          center: true
        }).then(() => {
           this.deleteDot(id);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('desktopDot.txt18')
          });       
        });
      },
      async deleteDot(id) {
        const {data: res} = await this.$http.post("/desktop/delete?id="+id);
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.$message({
          type: 'success',
          message: this.$t('desktopDot.txt19')
        });
        this.loadData();
      },
      // 编辑/详情
      handleDetail(row,type){
        this.$router.push({path: "/sceneRecordDetail",query: {type: type,id: row.id}});
      },
      // 页面切换
      handleCurrentChange(pageNum) {
        this.queryInfo.pageNum = pageNum;
        this.loadData();
      },
      handleSizeChange(pageSize){
        this.queryInfo.pageSize = pageSize;
        this.loadData();
      }
    },
  };
</script>

<style lang="less" scoped>
  .desktopDotPage{
    .w32{
       /deep/ .el-input,/deep/ .el-input__inner{
         width: 100% !important;
       }
     }
     /deep/ .el-transfer-panel{
      width: 42%;
     }
    /deep/ .el-button--primary{
      width: auto;
      height: auto;
      padding:0;
      background: none;
    }
    /deep/ .el-button--primary.is-disabled{
      background: none;
      border: none;
    }
    /deep/ .el-button+.el-button{
      margin-left: 0 !important;
    }
    /deep/ .el-transfer__buttons{
      padding:0;
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
    /deep/ .el-dialog{
      /deep/ .el-input,/deep/ .el-input__inner{
        width: 100% !important;
      }
      /deep/ .el-select{
        width: 100%;
      }
      /deep/ .el-dialog .el-dialog__body .el-select .el-input__inner, .el-dialog .el-dialog__body .el-input__inner, .el-dialog .el-dialog__body .el-input{
        border-radius: 8px; 
      }
    }
    .cardContent{
      width: 100%;
      margin-top: 1.6rem;
      margin-left: 0 !important;
      .cardBox:nth-of-type(3n+3){
        margin-right: 0;
      }
      .cardBox{
        padding:3rem !important; 
        background: #fff;
        border-radius: 3rem;
        margin-bottom: 3rem;
        margin-right: 3rem;
        width: 31.5%;
        .header{
          border-bottom: 1px solid #EBEEF3;
          padding-bottom: 2rem;
          span{          
            font-size: 1.4rem;
            font-weight: 400;
            color: #222;
            cursor: pointer;
          }
          img{
            width: 1.4rem;
            height: 1.8rem;
            margin-right: 2rem;
            cursor: pointer;
          }
          img:last-of-type{
            margin-right: 0;
          }
        }
        .contentBox{
          padding-top:3rem;
          .desktopPic{
            width: 10rem;
            height: 8rem;
            margin-right: 2rem;
          }
          p:first-of-type{
            margin-bottom:1.5rem;
          };
          p:nth-of-type(2){
            margin-bottom:1.5rem;
          };
          p{            
            font-size: 1.2rem;
            font-weight: 400;
            color: #999999;
            overflow: hidden;
            span{
              color: #666;
            }
            .dot{
              width: 1.2rem;
              height: 1.2rem;
              background: #1AA600;
              border-radius: 50%; 
              margin-right: 1.2rem;
              display: block;
              float: left;
              margin-top: 5px;
            }
            .greenDot{
              background: #D80000;
            }
          }
          .w19{
            width: 19%;
          }
          .labelTxt{            
            font-size: 1.4rem;
            margin-right: 1.4rem;
            font-weight: 400;
            color: #AEB0B9;
          }
          .txt{            
            font-size: 1.4rem;
            font-weight: 400;
            color: #222222;
            line-height: 2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
    .searchUserBox{
      width: 33.6rem !important;
      /deep/ .el-input-group__append{
        background: #fff !important;
        padding:0;
        border-left: none;
      }
    }
    
  }
</style>
